if (process.env.NODE_ENV === 'production') {
  module.exports = require('./type-size.production.js');
} else {
  module.exports = require('./type-size.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/type-size/dist/es/type-size.js
// module id = 116
// module chunks = 0